import RecoverPasswordWithEmailHeader from '@/features/auth/recover-password-form/recover-with-email/components/RecoverPasswordWithEmailHeader'
import { RecoverPasswordWithEmailForm } from '@/features/auth/recover-password-form/recover-with-email/components/RecoverPasswordWithEmailForm'
import { BaseView } from '@/components/base'

export function RecoverPasswordWithEmailScreen() {
  return (
    <BaseView flex={1} px={12} gap={20} className="h-full">
      <RecoverPasswordWithEmailHeader />
      <RecoverPasswordWithEmailForm />
    </BaseView>
  )
}
